import type { ReadinessBand } from '@/lib/api/org';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/cn';
import { BAND_META } from './readiness';

export function ReadinessBadge({ band }: { band: ReadinessBand }) {
  const meta = BAND_META[band];
  return (
    <Badge variant="outline" className={cn('gap-1.5 border-transparent font-medium', meta.badgeClass)}>
      <span className={cn('h-1.5 w-1.5 rounded-full', meta.dotClass)} />
      {meta.label}
    </Badge>
  );
}
